import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { IKIOSKModel, IKioskMessage, IKioskOtherServiceMenu, IkioskMenuIds } from '../../../../models/kioskModel';
import { Ilanguages } from '../../../../models/utilitiesModel';
import { menuTypeAction, setLanguage } from '../../../../store/actions';
import { getLabelConfigMsg } from "../../../../helpers/helpersIndex";

const LanguageSelection: React.FC = () => {
    const { t } = useTranslation("translations");
    const dispatch = useDispatch();
    const language: any = useSelector((state) => (state?.kioskReducer as IKIOSKModel)?.language);
    const logInPage: any = useSelector((state) => (state?.kioskReducer as IKIOSKModel)?.loginPage);
    const selectedPage: string = useSelector((state) => (state.kioskReducer as IKIOSKModel)?.selectedPage);
    const newPatientBranchdata: IKioskOtherServiceMenu = useSelector((state) => (state.kioskReducer as IKIOSKModel)?.isNewpatientRegistration || undefined);
    const kioskConfigMsgs: IKioskMessage[] = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.kioskConfigdata?.kioskMessage || []);
    console.log("language===>", language, newPatientBranchdata, selectedPage);
    const handleLanguage = (lang) => {
        dispatch(setLanguage(lang));
        if (logInPage === IkioskMenuIds.INSERTEMIRATESID) {
            dispatch(menuTypeAction(IkioskMenuIds.INSERTEMIRATESID));
        }
        else if (logInPage === IkioskMenuIds.NEWPATIENT) {
            dispatch(menuTypeAction(IkioskMenuIds.NEWPATIENT));
        }
        else if (logInPage === IkioskMenuIds.SCANQR) {
            dispatch(menuTypeAction(IkioskMenuIds.SCANQR));
        }
    }
    return (
        <div className='align-items-center d-flex flex-column mt-15 lang_select'>
            <span>{(getLabelConfigMsg(kioskConfigMsgs, Ilanguages.ARB, "plzselectLang") || t("kiosktranslation.plzselectLang-Ar"))}</span>
            <span>{(getLabelConfigMsg(kioskConfigMsgs, Ilanguages.ENG, "plzselectLang") || t("kiosktranslation.plzselectLang"))}</span>
            <div className='d-flex gap-3 mt-4'>
                <button type='button' className='Kiosk_button Kiosk_button_eng' onClick={() => handleLanguage(Ilanguages.ENG)}>{getLabelConfigMsg(kioskConfigMsgs, Ilanguages.ENG, "eng") || t("kiosktranslation.eng")}</button>
                <button type='button' className='Kiosk_button Kiosk_button_ar' onClick={() => handleLanguage(Ilanguages.ARB)}>{getLabelConfigMsg(kioskConfigMsgs, Ilanguages.ARB, "arb") ||t("kiosktranslation.arb")}</button>
            </div>
        </div>
    );
}
export default React.memo(LanguageSelection);